// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__IVyum","inner":"Form_inner__1W4Af","range":"Form_range__24oj6","name":"Form_name__1HKby","actions":"Form_actions__gH3eo"};